<template>
  <report-main @back="goBack">
    <template slot="nav">
      <div class="reportNav">
        <span v-if="reportForm.is_special_train === 1">【快】</span>
        <p>{{reportForm.name}}</p>
      </div>
    </template>
    <template slot="main">
      <div class="reportMain">
        <div class="content">
          <div class="scrollArea">
            <vue-scroll :ops="ops">
              <el-form :model="reportForm"
                       :rules="rules"
                       ref="reportForm"
                       class="reportForm"
                       label-position="top"
                       size="medium">
                <fieldset class="report-form-fieldset">
                  <legend>教练员培训班报告</legend>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="培训班组织情况:"
                                    prop="tissue_situation"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.tissue_situation"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入培训班组织情况">
                        </el-input>
                        <span class="len">{{reportForm.tissue_situation.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label="设施情况:"
                                    prop="facility_situation"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.facility_situation"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入设施情况">
                        </el-input>
                        <span class="len">{{reportForm.facility_situation.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="器材、装备情况:"
                                    prop="equipment_situation"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.equipment_situation"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入器材、装备情况">
                        </el-input>
                        <span class="len">{{reportForm.equipment_situation.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label="学员情况描述:"
                                    prop="student_situation"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.student_situation"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入学员情况描述">
                        </el-input>
                        <span class="len">{{reportForm.student_situation.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="食、宿条件:"
                                    prop="eating_situation"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.eating_situation"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入食、宿条件">
                        </el-input>
                        <span class="len">{{reportForm.eating_situation.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label="交通情况:"
                                    prop="traffic_situation"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.traffic_situation"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入交通情况">
                        </el-input>
                        <span class="len">{{reportForm.traffic_situation.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="对助理讲师的评价:"
                                    prop="assistant_teacher_evaluate"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.assistant_teacher_evaluate"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入对助理讲师的评价">
                        </el-input>
                        <span class="len">{{reportForm.assistant_teacher_evaluate.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="1">
                      <el-form-item label="对未来培训班的建议:"
                                    prop="class_suggest"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.class_suggest"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入对未来培训班的建议">
                        </el-input>
                        <span class="len">{{reportForm.class_suggest.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="备注:"
                                    prop="remark"
                                    class="item">
                        <el-input
                            type="textarea"
                            v-model="reportForm.remark"
                            :maxlength="len"
                            :rows="4"
                            placeholder="请输入备注">
                        </el-input>
                        <span class="len">{{reportForm.remark.length}}/{{len}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </fieldset>
                <template v-if="reportForm.studentFail.length">
                  <fieldset class="report-form-fieldset">
                    <legend>学员培训未通过详细原因</legend>
                    <el-form-item

                      v-for="(item, index) in reportForm.studentFail"
                      :prop="'studentFail.' + index + '.reason_info'"
                      :rules="{required: true, message: `请输入详细原因`, trigger: `blur`}"
                      class="item"
                      :key="index"
                    >
                      <div class="failImg">
                        <img :src="item.profile_picture || person " alt=""  style="width: 70px;height: 70px;border-radius: 50%" @error="imgErr1(index)">
                        <p >{{item.name}}</p>
                      </div>
                      <el-input
                        placeholder="在学员对收到的培训结果产生异议并进行申诉的情况下，本部分内容将被中国足协作为处理申诉的参考依据。请主讲师详细和客观填写。"
                        v-model="item.reason_info"
                        type="textarea"
                        :maxlength="150"
                        :rows="3"
                      >
                      </el-input>
                      <span class="len fail">{{item.reason_info ? item.reason_info.length : 0 }}/150</span>
                    </el-form-item>
                  </fieldset>
                </template>
                <template v-if="reportForm.teacher_eva.length">
                  <fieldset class="report-form-fieldset">
                    <legend>助理讲师评价表</legend>
                    <el-row v-if="showTemplate" >
                      <el-col :span="20">
                        <div class="tea-row" v-for="(item, index) in reportForm.teacher_eva">
                          <div class="left">
                            <div class="userImg">
                              <img :src="item.profile_picture || person"
                                   @error="imgErr(index)"
                                   alt="">
                            </div>
                            <div class="userInfo">
                              <p>姓名：{{item.name}}</p>
                              <p>手机号：{{item.mobile_phone}}</p>
                            </div>
                          </div>
                          <div class="right" >
                            <template v-if="item.has_eva === 1">
                              <upload-file :fileUrl.sync="item.tea_eva_url"></upload-file>
                              <div class="download">
                                <a v-if="item.tea_eva_url"
                                   :href="item.tea_eva_url"
                                   download="">
                                  <el-button type="primary">查看</el-button>
                                </a>
                              </div>
                            </template>
                            <template v-if="item.has_record === 1">
                              <div>
                                <el-button @click="getTemplate(item.teacher_id,item)" type="primary" :loading="item.loading" :disabled="item.loading" style="width: 110px">{{item.record_status==='complete' ? '查看/编辑' : '添加'}}</el-button>
                                <span v-if="item.record_status==='complete'" class="status_comment sucess">已提交</span>
                                <span v-if="item.record_status==='incomplete'||item.record_status===''" class="status_comment err">未提交</span>
                              </div>
                            </template>
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="3" :offset="1" >
                        <a href="/uploads/import_tpl/中国足协讲师评价表.docx" download="中国足协讲师评价表.docx" style="display:blcok;">
                          <el-button type="primary">下载模板</el-button>
                        </a>
                      </el-col>
                    </el-row>
                      <el-row v-else >
                          <el-col :span="24">
                              <div class="tea-row" v-for="(item, index) in reportForm.teacher_eva">
                                  <div class="left">
                                      <div class="userImg">
                                          <img :src="item.profile_picture || person"
                                               @error="imgErr(index)"
                                               alt="">
                                      </div>
                                      <div class="userInfo">
                                          <p>姓名：{{item.name}}</p>
                                          <p>手机号：{{item.mobile_phone}}</p>
                                      </div>
                                  </div>
                                  <div class="right comment">
                                      <template v-if="item.has_eva === 1">
                                          <upload-file :fileUrl.sync="item.tea_eva_url"></upload-file>
                                          <div class="download">
                                              <a v-if="item.tea_eva_url"
                                                 :href="item.tea_eva_url"
                                                 download="">
                                                  <el-button type="primary">查看</el-button>
                                              </a>
                                          </div>
                                      </template>
                                      <template v-if="item.has_record === 1">
                                          <div >
                                              <el-button @click="getTemplate(item.teacher_id,item)" type="primary" :loading="item.loading" :disabled="item.loading" style="width: 110px">{{item.record_status==='complete' ? '查看/编辑' : '添加'}}</el-button>
                                            <span v-if="item.record_status==='complete'" class="status_comment success" >已提交</span>
                                            <span v-if="item.record_status==='incomplete'||item.record_status===''" class="status_comment err">未提交</span>
                                          </div>
                                      </template>
                                  </div>
                              </div>
                          </el-col>
                      </el-row>
                  </fieldset>
                </template>
              </el-form>
            </vue-scroll>
          </div>
        </div>
        <div class="btns">
          <div v-if="showUploadBtn"
               class="btn success"
               @click="upReport">提交审核
          </div>
          <div class="btn success"
               @click="tempUpload">{{role_type === 'teacher' ? '暂时保存' : '保存' }}
          </div>
          <div class="btn success"
               @click="preStep">上一步
          </div>
          <div class="btn error"
               @click="cancelBack">取消
          </div>
        </div>
        <yioks-tips :tips="backWarn.tips"
                    :showTips="backWarn.flag"
                    @hideTips="hideBackTips"></yioks-tips>
        <yioks-tips :tips="uploadWarn.tips"
                    :showTips="uploadWarn.flag"
                    :loading="loading"
                    @hideTips="hideUploadTips"></yioks-tips>
        <yioks-tips :tips="tempSaveWarn.tips"
                    :showTips="tempSaveWarn.flag"
                    :loading="loading"
                    @hideTips="hideTempUploadTips"></yioks-tips>
        <yioks-tips :tips="preWarn.tips"
                    :showTips="preWarn.flag"
                    :loading="loading"
                    @hideTips="hidePreTips"></yioks-tips>
        <yioks-tips :tips="cancelWarn.tips"
                    :showTips="cancelWarn.flag"
                    @hideTips="hideCanCelTips"></yioks-tips>
        <promote-subject
                :showTips="showProSubject"
                :teacher_eva="reportForm.teacher_eva"
                :theory_info.sync="theory_info"
                :template_title="template_title"
                :teacher_id="this.teacher_id"
                :user_name="this.user_name"
                :promote_number="this.promote_number"
                @hideTips="hidePromoteSubject"></promote-subject>
      </div>
    </template>
  </report-main>
</template>

<script>
  import ops from '@/assets/js/vuescrollOption';
  import person from "@/assets/images/person.png";
  import {getReportInfo, uploadReport,promote_record_data,promote_template_data} from "@/api/training_teacher/api";
  import {storageData} from "@/assets/js/storage";
  let {entries} = Object;
  const role_type=storageData.getUserType();
  export default {
    name: "class-report",
    data() {
      const uploadWarn = {
        flag: false,
        tips: "确定提交审核吗？"
      };
      const tempSaveWarn = {
        flag: false,
        tips: role_type === 'teacher' ? "确定暂时保存吗？" : "确定保存吗？"
      };
      const preWarn = {
        flag: false,
        tips: "确定保存，并返回上一步吗?"
      };
      const backWarn = {
        flag: false,
        tips: "确定放弃修改并返回吗？"
      };
      const cancelWarn = {
        flag: false,
        tips: "确定放弃修改并返回吗？"
      };
      const len = 500;
      const rules = {
        tissue_situation: [
          {required: true, message: '请输入培训班组织情况', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        facility_situation: [
          {required: true, message: '请输入设施情况', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        equipment_situation: [
          {required: true, message: '请输入器材装备情况', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        student_situation: [
          {required: true, message: '请输入学员情况', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        eating_situation: [
          {required: true, message: '请输入食宿条件情况', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        traffic_situation: [
          {required: true, message: '请输入交通情况', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        assistant_teacher_evaluate: [
          {required: true, message: '请输入对助理讲师的评价', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        class_suggest: [
          {required: true, message: '请输入对未来培训班的建议', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
        remark: [
          {required: false, message: '请输入备注', trigger: 'blur'},
          {min: 1, max: len, message: `长度在 1 到 ${len} 个字符`, trigger: 'blur'}
        ],
      };
      return {
        ops: ops(),
        person,
        uploadWarn,
        tempSaveWarn,
        preWarn,
        backWarn,
        cancelWarn,
        len,
        role_type:role_type,
        showProSubject:false, //是否显示升迁表
        theory_info:{}, //首次传入理论课评价信息
        teacher_id:'', //讲师id
        user_name:'',// 讲师姓名
        promote_number:1,
        template_title:{}, //弹出框标题模板
        btnLoading:false, //评价按钮loading
        showTemplate:false, //是否显示下载模板
        uploadUrl: "/api/organization/upload_teacher_eva.json",
        repeatSubmit: false,
        showUploadBtn: false,
        reportForm: {
          tissue_situation: "", // 培训班组织情况
          facility_situation: "", // 设施情况
          equipment_situation: "", // 器材装备情况
          student_situation: "", // 学员情况
          eating_situation: "", // 食宿条件情况
          traffic_situation: "", // 交通情况
          assistant_teacher_evaluate: "", // 对助理讲师的评价
          class_suggest: "", // 对未来培训班的建议
          remark: "", // 备注
          status: "", // 保存状态  提交审核 or 暂时保存（Audit  or  Edit）
          teacher_eva: [], // 讲师评价 文件数据 teacher_id : 讲师id report_url: 文件路径
          studentFail:[],
          c_id: this.$route.query.c_id,
        },
        rules,
        loading: false,
      };
    },
    components: {
      "report-main": () => import("@/components/LayOut/Common/up-down"),
      "yioks-tips": () => import("@/components/Tips/Dialog"),
      "upload-file": () => import("@/components/score/components/upload-file"),
      "promote-subject":() => import("@/components/score/promote-subject")
    },
    created() {
      this.getReportData();
    },
    methods: {
      check() {
        let checkBool = false;
        let checkComemnt=false;
        this.$refs["reportForm"].validate((valid) => {
          if (valid) {
            checkBool = true;
            // 检验是否上传文件
            checkComemnt=true;
            //检验是否填写助理讲师评价
            this.reportForm.teacher_eva.map((item) => {
              if (!item.tea_eva_url && item.has_eva===1) {
                checkBool = false;
              }
              if( item.has_record===1 && item.record_status!='complete'  ){
                checkComemnt=false;
              }
            });
            if (!checkBool) {
              this.$message({
                type: 'error',
                message: '请上传教练员讲师评价表'
              });
            }
            if (!checkComemnt) {
              this.$message({
                type: 'error',
                message: '请填写助理讲师评价'
              });
            }
          } else {
            console.log('error submit!!');
          }
        });
        return checkBool && checkComemnt;
      },
      // 提交审核 Audit
      upReport() {
        this.check() && this.$set(this.uploadWarn, "flag", true);
      },
      hideUploadTips(bool, flag) {
        this.$set(this.uploadWarn, "flag", bool);
        flag && this.submitReport("Audit");
      },
      // 暂时保存 Edit
      tempUpload() {
        // this.check() && this.$set(this.tempSaveWarn, "flag", true);
        this.$set(this.tempSaveWarn, "flag", true);
      },
      hideTempUploadTips(bool, flag) {
        this.$set(this.tempSaveWarn, "flag", bool);
        flag && this.submitReport("Edit");
      },
      // 上一步 Back
      preStep() {
        // this.check() && this.$set(this.preWarn, "flag", true);
        this.$set(this.preWarn, "flag", true);
      },
      hidePreTips(bool, flag) {
        this.$set(this.preWarn, "flag", bool);
        flag && this.submitReport("Back");
      },
      goBack() {
        this.$set(this.backWarn, "flag", true);
      },
      hideBackTips(bool, flag) {
        this.$set(this.backWarn, "flag", bool);
        flag && this.$router.go(-1);
      },
      cancelBack() {
        this.$set(this.cancelWarn, "flag", true);
      },
      hideCanCelTips(bool, flag) {
        this.$set(this.cancelWarn, "flag", bool);
        flag && this.$router.go(-2);
      },
      // 关闭显示助理讲师升迁表弹出层
      hidePromoteSubject(bool){
        if(bool){
          console.log(1)
        }else {
          this.showProSubject=false
        }
      },
      //得到助理讲师的评价成绩，以及课题模板等
      getTemplate(id,item){
        item.loading=true;
        // this.btnLoading=true;
        this.teacher_id=id;
        this.user_name=item.name;
        promote_template_data({
          teacher_id:id,
          c_id:this.$route.query.c_id,
        }).then(res=>{
          if (res.data.status===0){
            this.template_title = res.data.result;
            this.promote_number=this.template_title.infoMap.promote_number;
            let theory_subject_info = {};
            let practice_subject_info = {};
            if  (this.template_title){
              for (let i in this.template_title.theorySubjectData){
                theory_subject_info[this.template_title.theorySubjectData[i].subject_id] = this.template_title.theorySubjectData[i].subject_name;
              }
              for (let i in this.template_title.practiceSubjectData){
                practice_subject_info[this.template_title.practiceSubjectData[i].subject_id] = this.template_title.practiceSubjectData[i].subject_name;
              }
              this.template_title["theory_subject_info"] = theory_subject_info;
              this.template_title["practice_subject_info"] = practice_subject_info;
              this.getTeaInfo(id,item)
            }
          } else {
            this.$message.error(res.data.msg);
            item.loading=false;
          }
        }).catch(err=>{
          console.log(err)
          item.loading=false;
        });
       },
      getTeaInfo(id,item){
        promote_record_data({
          teacher_id:id,
          promote_type:'theory',
          c_id:this.$route.query.c_id,
        }).then(res=>{
          if (res.data.status===0){
            const {evaluateDate,subjectData}=res.data.result;
            if (subjectData.length>0){
              for (let index in evaluateDate){
                evaluateDate[index].order=index+1;
                evaluateDate[index].score=Number( evaluateDate[index].score) / 2
              }
              //把当前的5个理论课主题在原始的主题模板中禁用
              let theory_subject_date = {};
              for (let index in subjectData){
                let result=subjectData[index].child_list;
                subjectData[index].order=index +1;
                for (let idx in result){
                  result[idx].score= Number(result[idx].score) / 2
                }
                theory_subject_date[subjectData[index].subject_id] =  subjectData[index].subject_name;
              }
              //如果5个主题在原始模板中存在，添加禁用属性
              if (this.template_title) {
                this.template_title.theorySubjectData.forEach(res => {
                  if (theory_subject_date[res.subject_id]) {
                    res.disabled = true;
                  }
                });
              }
              this.theory_info={
                evaluateDate:evaluateDate,
                subjectData:subjectData,
                teacher_id:id
              };
              item.loading=false;
              this.showProSubject=true;
            }else{
              //定义理论课主标题 subjectData
              const {record_id}=this.template_title.infoMap; //从模板获取record_id
              const {theoryComperData}=this.template_title; //获取模板中子标题
              const subject = {
                evaluate: "",
                evaluate_id: null,
                indicators_score: "",
                record_id: record_id,
                subject_id: '',
                subject_name: "",
                subject_type: "theory",
                keyUuid: this.uuid()
              };
              for (let j = 0; j < 5; j++) {
                subjectData.push({
                  ...subject,
                  child_list: this.child_list()
                })
              }
              //定义理论课综合表现 evaluateDate
              theoryComperData.forEach(comperData=>{
                evaluateDate.push({
                  record_id:record_id,
                  indicators_type:comperData.indicators_type,
                  indicators_name:comperData.indicators_name,
                  evaluate:'',
                  score:0,
                  indicators_id:comperData.indicators_id,
                  comprehensive_id:null,
                })
              });
              this.theory_info={
                evaluateDate:evaluateDate,
                subjectData:subjectData,
                teacher_id:id
              };
              item.loading=false;
              this.showProSubject=true;
            }
          } else{
            this.$message.error(res.data.msg);
            item.loading=false;
          }
        }).catch(err=>{
          item.loading=false;
          console.log(err)
        });
      },
      submitReport(status) {
        if (this.repeatSubmit) return;
        this.repeatSubmit = true;
        this.loading = true;
        this.$set(this.reportForm, "status", status);
        uploadReport({
          ...this.reportForm,
          teacher_eva: JSON.stringify(this.reportForm.teacher_eva),
          studentFail: JSON.stringify(this.reportForm.studentFail)
        })
          .then(({data}) => {
            this.loading = false;
            if (Number(data.status) === 0) {
              if(this.reportForm.status === "Edit"){
                this.$message.success("暂时保存成功");
              }else if( this.reportForm.status === "Audit"){
                this.$message.success("提交审核成功");
              }
              this.reportForm.status === "Back"
                ? this.$router.go(-1)
                : this.$router.go(-2);
            } else {
              this.$message({
                type: "error",
                message: data.msg || "提交失败"
              });
              throw new Error(data.msg || "提交失败");
            }
          })
          .catch((err) => {
            this.loading = false;
            this.repeatSubmit = false;
            console.error(err);
          });
      },
      getReportData() {
        getReportInfo({c_id: this.reportForm.c_id})
          .then(({data}) => {
            const {isShowAudit, trainReport, teacherEvaluate,studentFail} = data.result;
            this.showUploadBtn = isShowAudit;
            let tempReport = {};
            for (let [key, val] of entries(trainReport)) {
              val === null ? tempReport[key] = "" : tempReport[key] = val;
            }
            let tempEva = [];
            teacherEvaluate.length && (tempEva = teacherEvaluate);
            // 判断是否显示模板
            teacherEvaluate.forEach(tea=>{
                if (tea.has_eva===1) this.showTemplate=true;
            });
            let stuFail = [];
            studentFail.length && (stuFail = studentFail);
            this.reportForm = {
              ...this.reportForm,
              ...tempReport,
              teacher_eva: tempEva,
              assistant_teacher_evaluate: tempEva.length ? tempReport.assistant_teacher_evaluate : "无助理讲师"
            };
            this.reportForm.studentFail = stuFail.map((item) => {
              return {
                stu_id: item.stu_id,
                info_id: item.info_id ? item.info_id : 0,
                name:item.name,
                profile_picture:item.profile_picture,
                reason_info: item.reason_info ? item.reason_info : "",
              };
            })
          })
          .catch((err) => {
            console.error(err);
          });
      },
      imgErr(idx) {
        this.$set(this.reportForm.teacher_eva[idx], "profile_picture", this.person);
      },
      imgErr1(idx) {
        this.$set(this.reportForm.studentFail[idx], "profile_picture", this.person);
      },
      uuid() {
        let s = [];
        const hexDigits = "0123456789abcdef";
        for (let i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "";
        return s.join("");
      },
      child_list(){
        const {theoryIndicatorsData}=this.template_title; //获取模板中子标题
        let childList=[];
        theoryIndicatorsData.forEach((child,index)=>{
          childList.push({
            evaluate_id:null,
            score:0,
            score_id:null,
            indicators_id:child.indicators_id,
            indicators_type:child.indicators_type,
            indicators_name:child.indicators_name,
            keyUuid:this.uuid()
          })
        });
        return childList;
      }

    }
  }
</script>


<style lang="stylus">
  @import '~@/assets/css/variable';
  .reportMain {
    .content {
      .reportForm {
        .item {
          .el-form-item__label {
            font-size: $font_size_base;
            line-height: $font_size_base;
            color: $color_white;
          }
          .el-form-item__content{
            display flex
            justify-content center
            align-items center
            .failImg{
              width 108px
              margin-left 10px
              text-align left
              margin-top 20px
              height 100px
              img{
                width 81px
                height 70px
                border-radius 50%
              }
              p{
                text-align: center;
                margin-top: -15px;
                margin-left: -15px;
                height: auto;
                line-height: 20px;
              }
            }
          }
          .el-form-item__error{
            padding-top 8px
          }
        }
      }
    }
  }

</style>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  @import '~@/assets/css/mixin';
  .reportNav {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    font-size: $font_size_big;
  }

  .reportMain {
    width: 100%;
    height: 100%;
    .content {
      height: 92%;
      box-sizing: border-box;
      padding: 15px 0;
      background-color: $block_bg_color_base;
      .scrollArea {
        width: 100%;
        height: 100%;
        .reportForm {
          padding: 0 20px;
          .report-form-fieldset {
            margin: 0 0 20px 0;
            padding: 10px 10px 0;
            border: 1px solid $color_white;
            legend {
              font-size: $font_size_medium;
            }
          }
          .item {
            position: relative;
            .len {
              position: absolute;
              right: 6px;
              bottom: 4px;
              font-size: $font_size_base;
              line-height: $font_size_base;
              color: $color_info;
              user-select: none;
            }
            .fail{
              bottom 27px
            }
          }
          .tea-row {
            padding: 15px 20px;
            margin: 0 0 10px 0;
            display: flex;
            align-items: center;
            border: 1px solid $color_white;
            .left {
              display: flex;
              margin: 0 30px 0 0;
              .userImg {
                flex: 0 0 auto;
                display: flex;
                align-items: center;
                margin: 0 20px 0 0;
                img {
                  width: 70px;
                  height: 70px;
                  border-radius: 50%;
                }
              }
              .userInfo {
                flex: 1 1 auto;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                font-size: $font_size_medium;
              }
            }
            .right {
              flex: 1 1 auto;
              display: flex;
              justify-content: space-between;
              .btn{
                button{
                  color:$color_white
                  background-color :$color_suc
                  border  none
                }
              }
              .download {
                a {
                  display: block;
                }
              }
              .status_comment{
                margin-left 10px
                color $color_suc
              }
              .err{
                color $color_err
              }
            }
            .comment{
                justify-content center
                .status_comment{
                  margin-left 10px
                  color $color_suc
                }
                .err{
                  color $color_err
                }
            }
          }
        }
      }
    }
    .btns {
      height: 40px;
      margin: 10px 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn {
        height: 100%;
        margin: 0 20px;
        padding: 8px 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        line-height: $font_size_medium;
        border-radius: 5px;
        cursor: pointer;
        user-select: none;
      }
      .success {
        background-color: $color_suc;
      }
      .error {
        background-color: $color_err;
      }
    }
  }
</style>
<style lang="stylus" scoped>
  .el-form-item__content{
    display flex
  }
</style>
